import KeenSlider from "keen-slider";
import { animateCardsIn } from "../../utils/animateCardsIn";
import { CardMediaController } from "../../utils/cardMediaPool";

function fillSlider(container) {
  if (!container.offsetWidth) return;
  const slides = Array.from(container.children);
  if (!slides.length) return;

  const target = container.offsetWidth * 2;
  let total = slides.reduce((sum, s) => sum + s.offsetWidth, 0);

  while (total < target) {
    slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      container.appendChild(clone);
      total += slide.offsetWidth;
    });
  }
}

export default class ProductCardsSlider {
  constructor(el) {
    this.el = el;

    this.init();
  }

  init() {
    this.loop = this.el.dataset.loop !== 'false';

    if (this.loop) fillSlider(this.el);

    this.slider = new KeenSlider(this.el, {
      loop: this.loop,
      slides: {
        perView: "auto",
        spacing: 8,
      },
      breakpoints: {
        "(max-width: 767px)": {
          slides: { perView: "auto", spacing: 8, origin: "center" },
        },
      },
    });

    this.initResizeObserver();
    animateCardsIn(this.el);

    // Only slides actually on screen (originals AND keen-slider loop clones) get
    // a live player; off-track slides stay idle.
    this.mediaPool = new CardMediaController({
      hover: true,
      context: "product-card:slider",
    });
    this.syncMedia();
  }

  syncMedia() {
    this.mediaPool?.reset(this.el.querySelectorAll(".c-product-card"));
  }

  initResizeObserver() {
    let timer;
    this._resizeHandler = () => {
      clearTimeout(timer);
      timer = setTimeout(() => this.rebuild(), 200);
    };
    window.addEventListener("resize", this._resizeHandler);
  }

  rebuild() {
    this.slider.destroy();

    Array.from(this.el.querySelectorAll("[aria-hidden='true']")).forEach((el) =>
      el.remove()
    );

    if (this.loop) fillSlider(this.el);

    this.slider = new KeenSlider(this.el, {
      loop: this.loop,
      slides: {
        perView: "auto",
        spacing: 8,
      },
      breakpoints: {
        "(max-width: 1023px)": {
          slides: { perView: "auto", spacing: 8, origin: "center" },
        },
      },
    });

    this.syncMedia();
  }

  destroy() {
    window.removeEventListener("resize", this._resizeHandler);
    this.slider.destroy();
    this.mediaPool?.destroy();
  }
}
